import React from "react";
import { ChevronDown } from "lucide-react";

import { Button } from "../../../shadcn/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../../shadcn/components/ui/dropdown-menu";

// Multi-select filter: a toolbar button that opens a list of checkboxes.
// onChange receives { target: { name, value } } like a form field.
const MultiSelectFilter = ({
  name,
  label,
  options = [],
  value = [],
  onChange,
  icon,
  align = "start",
}) => {
  const selectedLabel = value.length ? `${label} (${value.length})` : label;

  const toggleOption = (optionValue) => {
    const nextValue = value.includes(optionValue)
      ? value.filter((selectedValue) => selectedValue !== optionValue)
      : [...value, optionValue];

    onChange({ target: { name, value: nextValue } });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={<Button type="button" variant="outline" />}
      >
        {icon}
        {selectedLabel}
        {!icon && <ChevronDown aria-hidden="true" />}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        aria-label={label}
        align={align}
        className="w-auto min-w-56"
      >
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={value.includes(option.value)}
            onCheckedChange={() => toggleOption(option.value)}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MultiSelectFilter;
